var map = {
	"./calcs/2018/processed/calc.json": 774,
	"./calcs/2019_01/processed/calc.json": 775,
	"./calcs/2019_06/processed/calc.json": 776,
	"./calcs/2019_08/processed/calc.json": 777,
	"./calcs/2019_08_tax/processed/calc.json": 778,
	"./calcs/2020_01/processed/calc.json": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;